import {MDCRipple} from '@material/ripple';

/**
 * Blog list cards effects
 */
export function listCardsEffects() {
  const selector = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
  [].map.call(document.querySelectorAll(selector), function(el) {
    return new MDCRipple(el);
  });

  const blogListCards = document.querySelectorAll(
      '.blog-list-card__primary-action');
  [].map.call(
      blogListCards, function(el) {
        el.addEventListener('click', function(e) {
          window.location = e.currentTarget.
              querySelector('.blog-list-card__href').
              getAttribute('href');
        });
      });

  const blogListCardsButtons = document.querySelectorAll(
      '.blog-list-card__button');
  [].map.call(
      blogListCardsButtons, function(el) {
        el.addEventListener('click', function(e) {
          window.location = e.currentTarget.getAttribute('data-href');
        });
      });
}
